import React from 'react';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles({
    footer: {
        marginTop: '24px',
        marginBottom: '24px',
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        gap: '24px'
    },
    line: {
        flex: 1,
        height: '1px',
        backgroundColor: '#E3E3FA'
    },
    dot: {
        width: '6px',
        height: '6px',
        borderRadius: '50%',
        backgroundColor: '#E3E3FA'
    }
});

const SuggestionSectionFooter: React.FC = () => {
    const classes = useStyles();

    return (
        <div className={classes.footer}>
            <div className={classes.line} />
            <div className={classes.dot} />
            <div className={classes.line} />
        </div>
    );
};

export default SuggestionSectionFooter;